export function spotifyArtistUrl(spotifyId: string): string {
    const id = spotifyId.trim();
    return `https://open.spotify.com/artist/${encodeURIComponent(id)}`;
}

export function appleMusicArtistUrl(appleMusicId: string): string {
    const id = appleMusicId.trim();
    return `https://music.apple.com/artist/${encodeURIComponent(id)}`;
}

export function formatArtistLastRelease(
    lastRelease?: API.MusicDistribution.ArtistLastRelease | null,
): string {
    if (!lastRelease?.name) {
        return '—';
    }
    let date = '';
    if (lastRelease.digital_release_date) {
        const parsed = new Date(lastRelease.digital_release_date);
        if (!Number.isNaN(parsed.getTime()) && parsed.getFullYear() >= 1990) {
            date = parsed.toLocaleDateString();
        }
    }
    if (date) {
        return `${lastRelease.name} (${date})`;
    }
    return lastRelease.name;
}
